'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ch4o = require('ch4o');
var sum = require('hash-sum');
var cluster = require('@shadom/cluster');
var validator = require('@shadom/validator');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var sum__default = /*#__PURE__*/_interopDefaultLegacy(sum);

class RamCache {
    store = {};
    index = [];
    set(key, value) {
        this.store[key] = value;
        this.index.push(key);
        return this;
    }
    get(key) {
        return this.store[key] ?? null;
    }
    delete(key) {
        const deleted = delete this.store[key];
        if (deleted) {
            this.index = this.index.filter(k => k !== key);
            return true;
        }
        return false;
    }
    has(key) {
        return this.store.hasOwnProperty(key);
    }
    // compare
    hasEntry(key, value) {
        console.log(key, value);
        return this.store[key] === value;
    }
    clear() {
        this.store = {};
        this.index = [];
        return this;
    }
    get size() {
        return this.index.length;
    }
}

const defaultPortalOptions = {
    allowDupRequest: true,
    allowExternalKeys: true,
    filterExtraData: true,
    requestFreezingTime: 0,
    cache: false,
};

/**
 * Entrance of a portal request
 * Private method of Portal
 * @param data payload
 * @this {Portal}
 * @private
 */
async function doTransmit(data, ticket) {
    if (!(this instanceof Portal)) {
        throw new TypeError(`doTransmit must be called on object which type is Portal`);
    }
    this.startTime = +new Date;
    this.beforeTransmit(data);
    // find transmit method or its alias
    let transmit;
    for (let transMethod of this.alias.transmit) {
        // co.log('#[f00]'+transMethod)
        if (validator.isFn(this[transMethod]) && this[transMethod] !== Portal.prototype[transMethod]) {
            transmit = this[transMethod];
            break;
        }
    }
    if (!transmit) {
        throw new TypeError(`At least one of '[${[...this.alias.transmit]}]' methods is overridden`);
    }
    const task = transmit.call(this, data);
    if (!(task instanceof Promise)) {
        throw new TypeError('`transmit` method should be async');
    }
    this.afterTransmit();
    return task.then(async (res) => {
        const status = res.status ?? 0;
        const data = res.data ?? res;
        const portal = this.type;
        const response = {
            raw: res,
            data,
            ticket,
            portal,
            status,
        };
        // Done trans but "values" not been parsed
        this.doneTransmit(response);
        // parse data using data cluster
        const values = await this.values.parse(data);
        this.dataReady(values);
        return {
            raw: res,
            status,
            data: values,
            ticket,
            portal,
        };
    });
}
/**
 * @class Portal
 * @property cache
 * @property payload
 * @property values dataset generated from datacluster
 */
class Portal {
    static id;
    static className;
    alias = {
        transmit: new Set(['transmit']),
        payload: new Set(),
    };
    rules = {};
    // Used to set data segments (AKA data groups) in payload, these names are treated as the same
    // structure for validating rules
    name; // The instance name
    type; // The Class name
    addr; // Where transmitting data to
    /** Set this to checkout data from result */
    values = null;
    options;
    startTime = 0;
    constructor(config, alias) {
        this.name = config.name;
        this.type = config.type.name ?? config.type;
        this.addr = config.addr;
        this.options = { ...defaultPortalOptions, ...config.options };
        this.values = new cluster.DataCluster(config.values);
        // console.log(this.values)
        // this.addAlias
        // console.log(alias)
        if (alias) {
            Object.entries(alias).every(([aliasType, aliasNames]) => {
                if (!this.alias[aliasType]) {
                    this.alias[aliasType] = new Set;
                }
                aliasNames.forEach((aliasName) => {
                    // console.log('add', aliasName)
                    this.alias[aliasType].add(aliasName);
                });
                return true;
            });
        }
        // console.log(this.alias)
        this.rules = [...this.alias.payload.values()].reduce((rules, ruleType) => {
            if (!config[ruleType]) {
                // console.warn(`Portal config '${ruleType}' not provided while specified in portal!`);
                return rules;
            }
            rules[ruleType] = { ...config[ruleType] };
            return rules;
        }, this.rules);
    }
    get time() {
        return +(new Date) - this.startTime;
    }
    beforeTransmit(data) {
        // console.log('before tr')
    }
    afterTransmit() {
        // console.log('after tr')
    }
    doneTransmit(res) {
        // console.log('done tr')
    }
    dataReady(res) { }
    /**
     * 从一个接口获取数据，属于双向的数据流传输过程
     * @param options
     * @returns
     */
    async transmit(payloads) {
        return null;
    }
    debounce() {
    }
    throttle() {
    }
}

/**
 * Utils for checking portal rules aganst portal's payload
 */
const [PORTAL, SEGMENT, KEY, RULE,] = [
    ch4o.ID('portal'),
    ch4o.ID('segment'),
    ch4o.ID('key'),
    ch4o.ID('rule'),
];
const messages = {
    ERR_RULE_TEST_FAIL: ch4o.TPL `Value of '${KEY}' not match portal rule '${RULE}'`,
    ERR_KEY_REQUIRED: ch4o.TPL `Key '${KEY}' of portal '${PORTAL}.${SEGMENT}' is required!`,
    ERR_SEGMENT_NOT_FOUND: ch4o.TPL `Segment '${SEGMENT}' not found in transmition payload!`,
    ERR_VALUE_EXACT_MATCH: ch4o.TPL `The value type of key '${KEY}' should be type of '${RULE}'`,
    ERR_EXT_KEYS: ch4o.TPL `Extra keys [${KEY}] not allowed in config of '${PORTAL}.${SEGMENT}'`,
};
function msgWrap(info, errors) {
    return (stat, msg = ch4o.TPL `OK`) => {
        if (!stat) {
            errors.push(`Invalid data for Portal: ${msg(info)}`);
        }
        return stat;
    };
}
function check(rule, value, modify, genErr) {
    if (rule instanceof validator.Validator) {
        return genErr(rule.test(value), messages.ERR_RULE_TEST_FAIL);
    }
    if (validator.isFn(rule)) {
        modify(rule(value));
        return true;
    }
    // optional
    if (rule === false) {
        return true;
    }
    // required 
    if (rule === true) {
        return genErr(validator.isRealValue(value), messages.ERR_KEY_REQUIRED);
    }
    // constant value(string, number) is the default value of 'value'
    if (validator.isStr(rule) && rule.startsWith('=')) {
        if (!validator.isRealValue(value)) {
            modify(JSON.parse(rule.slice(1)));
            return true;
        }
        return genErr(typeof rule === typeof value, messages.ERR_VALUE_EXACT_MATCH);
    }
    if (validator.isNum(rule) || validator.isObject(rule) || Array.isArray(rule)) {
        if (!validator.isRealValue(value)) {
            modify(rule);
            return true;
        }
        return genErr(typeof rule === typeof value, messages.ERR_VALUE_EXACT_MATCH);
    }
    return genErr(true);
}
function verify(portal, payload) {
    const jobInfo = {};
    const errors = [];
    const segments = portal.rules;
    const genErr = msgWrap(jobInfo, errors);
    jobInfo.portal = portal.name;
    const isValid = Object.entries(segments).every(([segName, rules = {}]) => {
        jobInfo.segment = segName;
        let values = payload[segName];
        // segName defined in portal's config but not exists in payload
        if (!values) {
            values = {};
            // return genErr(false, messages.ERR_SEGMENT_NOT_FOUND);
        }
        const allKeys = Object.keys(Object.assign({}, rules, values));
        // console.log('allkeys', allKeys)
        return [...allKeys].every((key) => {
            jobInfo.key = key;
            const rule = rules[key];
            const value = values[key];
            jobInfo.rule = String(rule);
            // extra keys
            if (validator.isUndef(rule)) {
                if (portal.options.filterExtraData) {
                    console.log(`%cFiltered extra data '${key}'`, 'color: #ccdd00;');
                    return delete values[key];
                }
                return genErr(portal.options.allowExternalKeys, messages.ERR_EXT_KEYS);
            }
            return check(rule, value, (value) => values[key] = value, genErr);
        });
    }, portal);
    return { isValid, errors };
}

exports.PortalErrorType = void 0;
(function (PortalErrorType) {
    PortalErrorType[PortalErrorType["PORTAL_NOT_FOUND"] = 0] = "PORTAL_NOT_FOUND";
    PortalErrorType[PortalErrorType["PAYLOAD_VERIFY_FAIL"] = 1] = "PAYLOAD_VERIFY_FAIL";
    PortalErrorType[PortalErrorType["PTE_COOLING_DOWN"] = 2] = "PTE_COOLING_DOWN";
    PortalErrorType[PortalErrorType["PTE_DUP_REQUEST"] = 3] = "PTE_DUP_REQUEST";
    PortalErrorType[PortalErrorType["PTE_TIMEOUT"] = 4] = "PTE_TIMEOUT";
    PortalErrorType[PortalErrorType["PPE_ENTRY_REQUIRED"] = 5] = "PPE_ENTRY_REQUIRED";
    PortalErrorType[PortalErrorType["PPE_RULE_TEST_FAIL"] = 6] = "PPE_RULE_TEST_FAIL";
    PortalErrorType[PortalErrorType["PPE_EXTRA_ENTRY_BLOCK"] = 7] = "PPE_EXTRA_ENTRY_BLOCK";
    PortalErrorType[PortalErrorType["PPE_EXTRA_ENTRY_FILTER"] = 8] = "PPE_EXTRA_ENTRY_FILTER";
})(exports.PortalErrorType || (exports.PortalErrorType = {}));
class PortalError extends Error {
    portal;
    type;
    constructor(message, errorInfo = {}) {
        super(message);
        this.type = errorInfo.type;
        this.portal = errorInfo.portal;
    }
}

/**
 * Portal 代表接口，继承这个类以实现不同各类的接口
 * 每种接口类型对应的规则以静态数据的形式（如JSON|toml）与Portal类的实现组合，实例化为portal对象
 * 即在应用的的时候（传送数据）portal作为单例的形式出现
 * 因此，对于调用的任务队列的处理，冲突处理（如 节流或防抖）是在Portal中实现的
 */
const requestCache = new RamCache;
// portal instances (PortalClass + PortalDef)
const portals = {};
const loadedPortals = {};
// Portal classes
const Portals = {};
// last used portal instance
let lastRequest = null;
/**
 * 供外部调用的方法, 向指定的portal发送数据
 * @param portalName
 * @param payload
 * @return Promise
 */
async function transmit(portalName, payload) {
    payload = ch4o.clone(payload);
    // let portal = loadedPortals[portalName];
    // if (!(portal instanceof Portal)) {
    const portal = await portals[portalName];
    if (!(portal instanceof Portal)) {
        throw new PortalError(`No portal named "${portalName}"`, { portal: portalName, type: exports.PortalErrorType.PORTAL_NOT_FOUND });
    }
    // loadedPortals[portalName] = portal;
    // }
    // 根据规则摘取数据
    // payload = genPackage(portal, payload); 
    const request = {
        portalName,
        payload,
        ticket: null,
        time: 0,
    };
    const ticket = sum__default["default"](request);
    request.ticket = ticket;
    request.time = +(new Date);
    console.log('%cCalling portal:', 'color: #660', request);
    // const pls = JSON.stringify(payload);
    // console.log(lastRequestedPortal, portal, portal === lastRequestedPortal)
    if (lastRequest?.portalName === portalName) {
        // 向同一个接口连续发送数据（不重复）通常是不允许的
        // 如果定义中指定了requestFreezingTime，则对请求的间隔时间进行校验
        const rft = portal.options['requestFreezingTime'];
        if (rft > 0) {
            if (request.time - lastRequest.time < rft) {
                throw new PortalError(`Portal '${portalName}' is cooling down!`, { portal: portalName, type: exports.PortalErrorType.PTE_COOLING_DOWN });
            }
        }
        // Wether allow request the same portal with the same data continuosly
        // 默认是false，即不允许 
        // 有时候是需要打开这个设置的，比如点赞的请求
        if (!portal.options['allowDupRequest']
            && requestCache.has(ticket)) {
            throw new PortalError(`Duplicated request on portal '${portalName}'!`, { portal: portalName, type: exports.PortalErrorType.PTE_DUP_REQUEST });
        }
    }
    const vr = verify(portal, payload);
    if (!vr.isValid) {
        return Promise.reject(vr.errors);
    }
    requestCache.set(ticket, request);
    lastRequest = request;
    return doTransmit.call(portal, payload, ticket);
}
/**
 * Reload a portal's transmission with the cached payload data
 * @param ticket You can obtain this id from the result data of a transmission, the last transmission will be used if omitted.
 */
async function reload(ticket) {
    let request = null;
    if (!ticket) {
        request = lastRequest;
    }
    if (!request) {
        if (requestCache.has(ticket)) {
            request = requestCache.get(ticket);
        }
        if (!request) {
            return Promise.reject(new ReferenceError(`No request found to reload!`));
        }
    }
    return doTransmit.call(await portals[request.portalName], request.payload);
}
/**
 * 注册一个Portal类型
 * @param PortalClass
 */
function use(PortalClass, name) {
    // Class or Function names are not reliable to be used to identify portals as they would be renamed by the compiler in a production build.
    // Using the 2nd param `name` of this function is recommended.
    const portalType = name || PortalClass.id || PortalClass.name;
    if (!(PortalClass?.prototype instanceof Portal) || !portalType) {
        throw new TypeError('Register Portal error: Not a valid PortalClass implementation');
    }
    if (Portals.hasOwnProperty(portalType)) {
        throw new Error(`Portal ${portalType} has already been registered`);
    }
    Portals[portalType] = PortalClass;
    console.log(`%cRegister PortalClass: '${portalType}'`, 'color: #39f');
    return true;
}
/**
 * 实例化Portal with portal config
 * this method binds the PortalClass and portalConfig(json from toml) together
 * 这个方法绑定了接口定义和接口类，它们为多对一的关系，即为，把每一个接口定义和相对应type的类绑定为一个实例
 * @param config portal's static config object
 * @throws
 * @returns
 */
function define(config) {
    let { name, type } = config;
    let portalType = type.name ?? type;
    if (!portalType || !name) {
        throw new TypeError(`Define a portal require "name" && "type"!`);
    }
    let TargetPortal = Portals[portalType];
    if (!TargetPortal) {
        throw new ReferenceError(`No portal class found with type of "${type}"`);
    }
    if (Object.prototype.hasOwnProperty.call(portals, name)) {
        throw new ReferenceError(`Portal '${name}' exists!`);
    }
    Object.defineProperty(portals, name, {
        async get() {
            let portal = loadedPortals[name];
            if (portal) {
                return portal;
            }
            portal = new TargetPortal(config);
            loadedPortals[name] = portal;
            return portal;
        }
    });
    // portals[name] = async () => new TargetPortal(options);
    return true;
}

exports.Portal = Portal;
exports.defaultOptions = defaultPortalOptions;
exports.define = define;
exports.reload = reload;
exports.transmit = transmit;
exports.use = use;
